
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19 6V16.5L20.95 18.45C20.98 18.3 21 18.15 21 18V6C21 4.9 20.1 4 19 4H6.5L8.5 6H19Z' fill='#323232'/><path d='M3.85989 3.95C3.50989 3.6 2.93989 3.6 2.58989 3.95C2.23989 4.3 2.23989 4.87 2.58989 5.22L2.99989 5.64V18C2.99989 19.1 3.89989 20 4.99989 20H17.3599L18.7799 21.42C19.1299 21.77 19.6999 21.77 20.0499 21.42C20.3999 21.07 20.3999 20.5 20.0499 20.15L3.85989 3.95ZM4.99989 18V7.64L15.3599 18H4.99989Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-browser-not-supported`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBrowserNotSupported

    ```js
    <b-new-b-icon-browser-not-supported />
    ```
</docs>


